<div *ngIf="formObject">
  <ng-container *ngIf="!invalidInput else invalidField">
    <mat-form-field appearance="standard" class="w-100">
      <mat-label [ngStyle]="isFirst ? {'visibility': 'visible'} : {'visibility' : 'hidden'}">
        {{label}}
        <sup *ngIf="isInfo">
          <mat-icon class="fas fa-info" style="font-size: 0.5rem"></mat-icon>
        </sup>
      </mat-label>
      <input matInput #inputElement
             [required]="required"
             [type]="type ? type : 'text'"
             [placeholder]="label"
             [matAutocomplete]="auto"
             [name]="elementName"
             [disabled]="isDisabled"
             [(ngModel)]="ngModelObject"
             (focusin)="getOptions(ngModelObject)"
             (focusout)="emitValue()"
             (ngModelChange)="emitChangeToGetOptions($event, inputElement)">
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setSelectedOption($event)">
        <mat-option *ngFor="let option of options" [value]="option">
          {{option}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </ng-container>
</div>

<ng-template #invalidField>
  <mat-form-field appearance="standard" class="w-100 mat-form-field-invalid ng-invalid">
    <mat-label [ngStyle]="isFirst ? {'visibility': 'visible'} : {'visibility' : 'hidden'}">
      {{label}}
      <sup *ngIf="isInfo">
        <mat-icon class="fas fa-info" style="font-size: 0.5rem"></mat-icon>
      </sup>
    </mat-label>
    <input matInput #inputElement
           [required]="required"
           [type]="type ? type : 'text'"
           [placeholder]="label"
           [(ngModel)]="ngModelObject"
           [matAutocomplete]="auto"
           [name]="elementName"
           [disabled]="isDisabled"
           (focusin)="getOptions(ngModelObject)"
           (focusout)="emitValue()"
           (ngModelChange)="emitChangeToGetOptions($event, inputElement)">
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setSelectedOption($event)">
      <mat-option *ngFor="let option of options" [value]="option">
        {{option}}
      </mat-option>
    </mat-autocomplete>
    <mat-hint align="start" class="mt-1">{{errorMessage}}</mat-hint>
  </mat-form-field>
</ng-template>
